import Constant from '@/const';
import axios from 'axios';

const deleteProcedure = async id => {
  try {
    const response = await axios.delete(
      Constant.apiUrl.concat(`/master/procedure/${id}`),
    );
    return response;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default deleteProcedure;
